import "core-js/modules/es.array.from";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getMonthTargetCounter, getTotalCounter, getMonthTotalCounter } from '@/api/bairun/financialCenter';
import dateUtils from '@/utils/dateUtil';
import MultiLineChart from '@/components/Charts/MultiLineChart';
import NP from 'number-precision';
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
  name: 'SlotCounterTotal',
  components: {
    MultiLineChart: MultiLineChart
  },
  props: {
    start: {
      type: Number,
      required: true
    },
    end: {
      type: Number,
      required: true
    },
    totalId: {
      type: Number,
      default: 999
    },
    tableHeight: {
      type: Number,
      default: 720
    },
    totalCounterName: {
      type: String,
      default: ''
    },
    totalCounterDisplayName: {
      type: String,
      default: '趋势'
    },
    totalCounterKind: {
      type: String,
      default: ''
    },
    slotCounterName: {
      type: String,
      required: true
    },
    trendShow: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      switchValue: false,
      loading: false,
      chartLoading: false,
      dialogFormVisible: false,
      limitViewKey: '',
      limitView: false,
      slotOption: '',
      selectedArea: '全部',
      totalStats: null,
      slotStats: null,
      compareTotalStats: null,
      compareSlotStats: null,
      groupData: [],
      xAxisData: [],
      yAxisDatas: {},
      compareMapping: [],
      metricsArr: ['销量近期趋势'],
      borderFix: ['合计/L', '合/L', '0#'],
      filterMapping: [{
        text: '佛山',
        value: '佛山'
      }, {
        text: '粤西',
        value: '粤西'
      }, {
        text: '外省',
        value: '外省'
      }],
      showStations: [],
      customColors: [{
        color: '#909399',
        percentage: 30
      }, {
        color: '#f56c6c',
        percentage: 60
      }, {
        color: '#e6a23c',
        percentage: 85
      }, {
        color: '#409eff',
        percentage: 99
      }, {
        color: '#67c23a',
        percentage: 100
      }],
      chartSellerId: 0,
      chartQStart: 0,
      chartQEnd: 0,
      chartTimeSplit: 0,
      chartTitle: '',
      stationTarget: [],
      timeSlots: []
    };
  },
  watch: {
    end: function end() {
      this.loadTarget(this.end);
      this.loadTotalData();

      if (this.chartTimeSplit === 1) {
        this.chartQStart = this.end / 1000;
        this.chartQEnd = this.end / 1000 + 86400;
      } else if (this.chartTimeSplit === 24) {
        this.chartQStart = this.end / 1000 - 7 * 24 * 60 * 60;
        this.chartQEnd = this.end / 1000;
      } // console.log('watch',this.chartSellerId, this.chartQStart, this.chartQEnd, this.chartTimeSplit, this.chartTitle)


      this.loadData(this.chartSellerId, this.chartQStart, this.chartQEnd, this.chartTimeSplit, 'beforeNums', this.chartTitle);
    }
  },
  computed: _objectSpread({}, mapGetters('stations', ['asyncStations'])),
  created: function created() {
    this.loadTarget(this.end);

    for (var i in this.asyncStations) {
      this.compareMapping.push({
        text: this.asyncStations[i]['statTag'],
        value: this.asyncStations[i]['ID'],
        sellerId: this.asyncStations[i]['ID']
      });
    }

    this.loadTotalData();
  },
  updated: function updated() {
    var _this = this;

    this.$nextTick(function () {
      _this.$refs.tableStation.doLayout();
    });
  },
  methods: {
    checkLimitViewKey: function checkLimitViewKey() {
      var month = moment().format('YYMM');
      var codePref = parseInt(this.sellerId) - 9000;
      var verifyKey = parseInt(codePref + '' + month).toString(8);

      if (this.limitViewKey === verifyKey) {
        this.limitView = true;
        this.dialogFormVisible = false;
        return;
      }

      _Message({
        message: '秘钥校验失败',
        type: 'error',
        duration: 3 * 1000
      });
    },
    npPlus: function npPlus() {
      var res = 0;

      for (var i in arguments) {
        res = NP.plus(res, arguments[i]);
      }

      return res;
    },
    filterHandler: function filterHandler(value, row, column) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i]['ID'] === row['sellerId'] && this.asyncStations[i]['statArea'] === value) {
          return true;
        }
      }

      return false;
    },
    filterChange: function filterChange(selected) {
      this.selectedArea = selected['area'] && selected['area'][0] ? selected['area'][0] : '全部';
    },
    progressFormat: function progressFormat(value) {
      return function () {
        return value + '%';
      };
    },
    cellStyle: function cellStyle(_ref) {
      var row = _ref.row,
          column = _ref.column;

      if (this.borderFix.includes(column.label)) {
        return 'border-right:1px solid #000000';
      }
    },
    getCusAppId: function getCusAppId(sellerId) {
      for (var i in this.compareMapping) {
        if (this.compareMapping[i].sellerId === sellerId) {
          return this.compareMapping[i].appId;
        }
      }

      return '';
    },
    numberFix: function numberFix(number, len) {
      return dateUtils.numberFix(number, len);
    },
    showDetail: function showDetail(number, len) {
      return dateUtils.numberFix(number, len);
    },
    sellerName: function sellerName(sellerId) {
      for (var i in this.asyncStations) {
        if (this.asyncStations[i].ID === sellerId) {
          return this.asyncStations[i]['statAbbr'];
        }
      }

      return '';
    },
    sellerTarget: function sellerTarget(sellerId, month) {
      if (!this.stationTarget || this.stationTarget.length === 0) {
        return 0;
      }

      for (var i in this.stationTarget) {
        if (this.stationTarget[i]['stationId'] === sellerId) {
          return this.stationTarget[i]['target'];
        }
      }

      return 0;
    },
    loadTarget: function loadTarget(datetime) {
      var _this2 = this;

      getMonthTargetCounter({
        'month': moment(datetime).format('YYYYMM')
      }).then(function (response) {
        _this2.stationTarget = response.data;
      });
    },
    loadTotalData: function loadTotalData() {
      var _this3 = this;

      if (this.loading) {
        return;
      }

      this.loading = true;
      var descriptorData = {
        descriptors: [{
          type: 'ocosotpc',
          operator: 'dateOCOSOTPC',
          name: this.slotCounterName,
          start: this.end / 1000 - 24 * 60 * 60,
          end: this.end / 1000,
          search: this.totalId === 999 ? '' : this.totalId.toString()
        }]
      };
      getTotalCounter(descriptorData).then(function (response) {
        var tempGroupData = Object.values(response.data);
        _this3.groupData = tempGroupData.sort(function (a, b) {
          var orders = [10006, 10003, 10011, 10013, 10010, 10014, 10001, 10012, 10002, 10005, 10004, 10009, 10008, 10015]; // // console.log('sort orders', orders.indexOf(a.sellerId), orders.indexOf(b.sellerId))

          return orders.indexOf(a.sellerId) - orders.indexOf(b.sellerId);
        });
        _this3.loading = false;
      }).catch(function () {
        _this3.loading = false;
      });
    },
    loadData: function loadData(sellerId, qStart, qEnd, timeSplit, sSlot, title) {
      var _this4 = this;

      if (this.chartLoading || !sellerId) {
        return;
      }

      this.chartSellerId = sellerId;
      this.chartQStart = qStart;
      this.chartQEnd = qEnd;
      this.chartTimeSplit = timeSplit;
      this.chartTitle = title;
      var stationName = this.sellerName(sellerId);
      this.chartLoading = true;
      var descriptorData = {
        descriptors: [{
          type: 'ocosotpc',
          operator: 'dateOCOSOTPC',
          t: sellerId,
          name: this.slotCounterName,
          start: qStart,
          end: qEnd,
          search: ''
        }]
      };

      if (sSlot !== '') {
        this.timeSlots = [sSlot];
      }

      getMonthTotalCounter(descriptorData).then(function (response) {
        _this4.chartLoading = false;
        var stats = response.data; // console.log('getMonthTotalCounter', stationName, stats)

        _this4.totalStats = {};

        for (var x = _this4.start / 1000; x <= _this4.end / 1000; x += 24 * 3600) {
          var formatX = dateUtils.timeStampToString(x, 'MMDD');
          _this4.totalStats[formatX] = 0;

          for (var index in _this4.timeSlots) {
            var slot = _this4.timeSlots[index];

            if (stats[formatX] !== undefined && stats[formatX][slot] !== undefined) {
              _this4.totalStats[formatX] += stats[formatX][slot];
            }
          }
        }

        _this4.metricsArr = [stationName + ' ' + title]; // console.log('getMonthTotalCounter => totalStats', this.totalStats)

        _this4.updateRetentionTrend(qStart, qEnd, timeSplit);
      }).catch(function () {
        _this4.chartLoading = false;
      });
    },
    timestamp2datestring: function timestamp2datestring(ts) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return dateUtils.timeStampToString(ts, format);
    },
    totalColumn: function totalColumn(ts) {
      if (!this.totalStats || this.totalStats[ts] === undefined) {
        return 0;
      } else {
        return this.numberFix(this.totalStats[ts], 2);
      }
    },
    updateRetentionTrend: function updateRetentionTrend(qStart, qEnd, timeSplit) {
      var retentionTrendData;

      if (timeSplit === 1) {
        retentionTrendData = this.slotStats[qStart];
      } else {
        retentionTrendData = this.totalStats;
      } // console.log(22333444, retentionTrendData)


      this.xAxisData = [];
      this.yAxisDatas = {};

      if (this.metricsArr.length > 0) {
        for (var i in this.metricsArr) {
          var chartName = this.metricsArr[i];
          this.yAxisDatas[chartName] = [];
        }
      }

      for (var timestamp = qStart; timestamp <= qEnd; timestamp += timeSplit * 3600) {
        var timestampKey = '';

        if (timeSplit === 1) {
          timestampKey = parseInt(dateUtils.timeStampToString(timestamp, 'HH'));
          this.xAxisData.push(dateUtils.timeStampToString(timestamp, 'HH'));
        } else {
          timestampKey = dateUtils.timeStampToString(timestamp, 'MMDD');
          this.xAxisData.push(timestampKey);
        }

        if (this.metricsArr.length > 0) {
          var metric = this.metricsArr[0];

          if (!this.totalStats || retentionTrendData[timestampKey] === undefined) {
            this.yAxisDatas[metric].push(0);
          } else {
            this.yAxisDatas[metric].push(NP.round(retentionTrendData[timestampKey], 2));
          }
        }
      }

      this.xAxisData = Array.from(new Set(this.xAxisData)); // console.log(111,this.xAxisData)
      // console.log(222,this.yAxisDatas)
    }
  }
};